<template>
  <OmtLayoutContainer
    :minHeight="['initial', 'calc(100vh - 80px)']"
    :alignContent="['', 'flex-start']"
  >
    <OmtRow mb="24px">
      <LineStepper
        :currentStep="2"
        :totalSteps="2"
      />
    </OmtRow>
    <OmtRow mb="8px">
      <OmtTypography
        as="h1-bold"
        lineHeight="32px"
        >Exames selecionados</OmtTypography
      >
    </OmtRow>
    <OmtRow mb="16px">
      <CFlex justify="space-between">
        <OmtTypography
          as="p2"
          color="var(--colors-light-primary-gray2)"
          >{{ selectedExams.length }} exame(s) selecionado(s)</OmtTypography
        >
        <CBox @click="clearSelectItems()">
          <OmtTypography
            as="button-small"
            color="var(--colors-light-primary-navy-blue)"
            cursor="pointer"
          >
            Limpar tudo
          </OmtTypography>
        </CBox>
      </CFlex>
    </OmtRow>
    <OmtRow
      v-for="(exam, index) in selectedExams"
      :key="index"
    >
      <OmtCard mb="16px">
        <CFlex>
          <CoverageAnalysesResult
            :name="exam.Descricao"
            :result="getResult(exam)"
            :isDut="exam.RequerDut"
          />
          <OmtIcons
            cursor="pointer"
            name="minus"
            size="lg"
            @click="removeItem(exam)"
          />
        </CFlex>
      </OmtCard>
    </OmtRow>
    <FixedButtonRow>
      <CFlex
        direction="column"
        :w="['100%', '308px !important']"
        align="center"
      >
        <OmtButton
          v-if="getLabelButton.length"
          variant="ghost"
          @click="goToRoute()"
        >
          <OmtTypography
            as="button-medium"
            color="var(--colors-light-primary-navy-blue)"
            mb="8px"
          >
            {{ getLabelButton }}
          </OmtTypography>
        </OmtButton>

        <ButtonCounter
          :w="['100%', '308px !important']"
          :count="selectedExams.length"
          :disabled="!selectedExams.length"
          label="Salvar"
          fontSize="20px"
          fontWeight="700"
          @click="finish"
        />
      </CFlex>
    </FixedButtonRow>
  </OmtLayoutContainer>
</template>

<script>
// Components
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";
import LineStepper from "@/components/Atoms/LineStepper/index.vue";
import ButtonCounter from "@/components/Molecules/ButtonCounter";
import CoverageAnalysesResult from "@/components/Molecules/CoverageAnalysesResult/index.vue";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: { LineStepper, FixedButtonRow, CoverageAnalysesResult, ButtonCounter },
  computed: {
    ...mapGetters("coverageAnalysis", ["hasRequiresAuthorization", "hasExamNotFound"]),
    ...mapState("coverageAnalysis", ["selectedExams"]),
    getLabelButton() {
      if (this.hasExamNotFound && this.hasRequiresAuthorization) {
        return "Salvar e enviar documentos";
      }

      if (this.hasExamNotFound) {
        return "Salvar e enviar pedido";
      }

      if (this.hasRequiresAuthorization) {
        return "Salvar e solicitar autorização";
      }

      return "";
      // desabilitando temporariamente a opção de ver laboratórios
      //return "Salvar e ver laboratórios";
    }
  },
  methods: {
    ...mapActions("coverageAnalysis", ["clearSelectedExams", "selectExam", "finishSimulation"]),
    async removeItem(item) {
      this.selectExam({ CodigoExame: item.CodigoExame, Descricao: item.Descricao, value: false });

      this.$toast({
        description: "Exame removido",
        status: "success",
        duration: 2000,
        position: "top"
      });

      if (this.selectedExams?.length === 0) {
        this.$router.push({ name: "analise_cobertura.nova_analise" });
      }
    },
    async clearSelectItems() {
      this.clearSelectedExams();
      this.$router.push({ name: "analise_cobertura.nova_analise" });
    },
    getResult(exam) {
      if (exam?.CodigoExame === "") {
        return "request";
      }

      if (exam?.ExigeAutorizacao) {
        return "authorization";
      }

      return "coverage";
    },
    async goToRoute() {
      if (this.hasExamNotFound) {
        this.$router.push({ name: "create.request", query: { tipo: "pedido" } });
      } else if (this.hasRequiresAuthorization) {
        this.$router.push({ name: "auths.create" });
      } else {
        this.$root.$emit("show-loading");
        const response = await this.finishSimulation({ obterLaboratorios: true });
        this.$root.$emit("hide-loading");
        this.$router.push({ name: "analise_cobertura.ver_laboratorios", query: { id: response } });
      }
    },
    async finish() {
      this.$root.$emit("show-loading");
      await this.finishSimulation({ obterLaboratorios: false });
      this.$root.$emit("hide-loading");
      this.$router.push({ name: "analise_cobertura.cobertura" });
    }
  },
  mounted() {
    if (this.selectedExams.length === 0) {
      this.$router.push({ name: "analise_cobertura.nova_analise" });
      return;
    }
    this.$root.$emit("hide-loading");
  }
};
</script>
